import _ from "lodash"

export const getClientRemisierCode = client => _.get(client,['remisier_code'],'')
export const getClientClientCode = client => _.get(client,['client_code'],"")
export const getClientCurrencyCode = client => _.get(client,['currency_code','symbol'],"")
export const getClientDueDate = client => _.get(client,['due_date','value'],"")
export const getClientContractReference = client => _.get(client,['contract_reference'],"")
export const getClientStockCode = client =>_.get(client,['stock_code'],"")
export const getClientStockName = client => _.get(client,['stock_name'],"")
export const getClientOutstandingAmount = client => _.get(client,['outstanding_amount','value'],'')
export const getClientOutstandingAmountFullText = client => _.get(client,['outstanding_amount','full_text'],'')
export const getClientOutstandingQuantity= client => _.get(client,['outstanding_quantity'],'')
export const getClientTransactionPrice= client => _.get(client,['transaction_price','value'],'')
export const getClientTransactionPriceFullText= client => _.get(client,['transaction_price','full_text'],'')
